import Subscription from "views/PublicPricingView";

export default function Page() {
  return (
    <>
      <Subscription />
    </>
  );
}
